// extracted by mini-css-extract-plugin
export var icon = "_60-1";
export var subtext = "_60-0";